import halfLogo from "./assets/images/halfLogo.png";
import SubBrandLogo from "./assets/images/elagii.png";
import fullLogo from "./assets/images/tenant-logos/Medco_full_Logo.png";

const tenantsTheme = {
  elagi: {
    name: "Elagi",
    logo: require("./assets/images/tenant-logos/elagi.png"),
  },
  alexelagi: {
    name: "Alexandria Medical Centre",
    logo: require("./assets/images/tenant-logos/alexelagi.png"),
  },
  health_one: {
    name: "Health One",
    logo: require("./assets/images/tenant-logos/alexelagi.png"),
  },
};

class BrandingTheme {
  constructor(tenantTheme) {
    if (tenantTheme) {
      this.tenantName = tenantsTheme[tenantTheme].name;
      this.tenantLogo = tenantsTheme[tenantTheme].logo;
    }
    this.BrandName = "Med-CO";
    this.BrandLogo = halfLogo;
    this.FullBrandLogo = fullLogo;
  }
}

export default BrandingTheme;
